/**
 * EMZI NEXUS — environment detection helper.
 *
 * Returns true when the app is running on a real production host. Used to
 * hide demo-login buttons, lock un-released studios, etc.
 *
 * Production hosts:
 *   - nexus.emzi.com.my       (legacy)
 *   - studio.emzinexus.com    (current)
 *   - any subdomain of emzinexus.com that doesn't contain "preview"
 *   - any host listed in REACT_APP_PRODUCTION_HOSTS (comma-separated)
 *
 * Development hosts:
 *   - localhost
 *   - *.preview.emergentagent.com
 *   - anything else not in the production list
 */

const PRODUCTION_HOSTS = [
  'nexus.emzi.com.my',
  'studio.emzinexus.com',
];

export const isProductionHost = () => {
  const host = (window?.location?.hostname || '').toLowerCase();
  if (!host) return false;

  const extra = (process.env.REACT_APP_PRODUCTION_HOSTS || '')
    .split(',')
    .map((h) => h.trim().toLowerCase())
    .filter(Boolean);

  if ([...PRODUCTION_HOSTS, ...extra].includes(host)) return true;

  // Allow any *.emzinexus.com host (excluding *.preview.*)
  if (/\.emzinexus\.com$/i.test(host) && !host.includes('preview')) return true;

  return false;
};

export const isDevelopmentHost = () => !isProductionHost();
